import React,{useState,useEffect} from 'react';
import {useHistory} from 'react-router-dom';

import BusDetailedTabs from '../BusDetailedCard/ItinaryTabs/Tabs';
import SelectSeatTabContent from '../BusDetailedCard/SelectSeatTabContent/SelectSeatTabContent';
import AmenitiesPhotos from '../BusDetailedCard/AmenitiesPhotosTabContent/AmenitiesPhotos';
import BoardingDroping from '../BusDetailedCard/BoardingDropingTabContent/BoardingDroping';
import PolicesContent from '../BusDetailedCard/PolicesTabContent/Polices';
import RnRPopup from '../BusDetailedCard/RnRPopup/RnRPopup';
import RnRTabContent from '../BusDetailedCard/RnRTabContent/RnRTabContent';
import * as S from './SeatSectionWrapper.styles';//Todo:- seperate the css from srpactive card
import {useSelector,useDispatch} from 'react-redux';
import {selectedSeatLayoutDataSelector,ratingAndReviewDataSelector,busDetailSelector} from './../../../../containers/SeatLayout/redux/selectors'
import {fetchSeatLayoutData,fetchRatingReviewData,fetchRedDealData,fetchCancellationPolicy,fetchBusDetails, fetchRedDealDataNew} from './../../../../containers/SeatLayout/redux/thunks';
import {categoryConfig,seatTabConfig} from './../../../../containers/SeatLayout/helpers/config'
import useConstant from 'use-constant';
import awesomeDebouncePromise from 'awesome-debounce-promise';
import {useAsync} from 'react-async';
import {commonSelector} from './../../../../containers/Common/redux/selectors';
import{fetchReviewData} from './../../../../containers/Review/redux/thunks';
import{prepareBookingKey,prepareQueryData,getReviewPageURL,getOldReviewPageURL} from './../../../../containers/Review/Utils';
import Popup from './../../../../../stories/core-components/Popup/Popup';
import {updateSelectedBusData} from './../../../../containers/SeatLayout/redux/actions';
import {pushga,pushEcommerceGAEvent} from 'ga-utils';
import {SeatLayoutEvents} from './../../../../config/ga-config';
import {prepareBookingData} from './../../../../containers/Review/Utils';
import {scrollEletoView,pushDataToNewrelic,getQueryString} from './../../../../containers/Common/Utils';
import { pushCtaOmniEvents } from '../../../../../shared/utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../../shared/utils/PushEvents/Omniture/utils'

const SeatSectionWrapper = (props:any) => {
  const dispatch = useDispatch();
  const history = useHistory();
 
  const {doj} = useSelector(commonSelector);
  const seatLayoutData = useSelector(selectedSeatLayoutDataSelector);// data of seats
  if (props.selectedSeatCopy) {
    for (let key in props.selectedSeatCopy) {
      if (props.selectedSeatCopy[key]?.selectedSeats?.upper_deck) {
        props.selectedSeatCopy[key]?.selectedSeats?.upper_deck.map((item, ind) => {
          if (seatLayoutData[key]?.data?.seats?.upper_deck[item] && seatLayoutData[key]?.data?.seats?.upper_deck[item]?.isAvailable === false) {
            props.selectedSeatCopy[key]?.selectedSeats?.upper_deck.splice(ind, 1)
          }
        })
      }
      if (props.selectedSeatCopy[key]?.selectedSeats?.lower_deck) {
        props.selectedSeatCopy[key]?.selectedSeats?.lower_deck?.map((item, ind) => {
          if (seatLayoutData[key]?.data?.seats?.lower_deck[item] && seatLayoutData[key]?.data?.seats?.lower_deck[item]?.isAvailable === false) {
            props.selectedSeatCopy[key]?.selectedSeats?.lower_deck?.splice(ind, 1)
          }
        })
      }
    }
  }
  const ratingAndReviewData= useSelector(ratingAndReviewDataSelector);//rating review data 
  const busDetails = useSelector(busDetailSelector)// bus details info //amentities/policies/dp/bp/rs/rating/review
  const [selectedLayouts,setSelectedSeatLayoutInfo]  = useState(props.selectedSeatCopy ? props.selectedSeatCopy : {}); // selected bus seats info
  const [showAllReview,toggleAllReviewView] = useState(false);
  const [cancellationPolicyData,setCancellationPolicyData] =useState({});
  const [isFareUpdating,setFareUpdateFlag] = useState(false);

  const [popupContent, setPopupContent] = useState({title: '', content: ''});

  const {bid,busData,selectedBusIds,selectedLinkName,routeId} = props;
  const {rs,chooseBpDpFirst,cat_card,cat_list, src_vid, dest_vid} = busData;
  let bps= [],dps=[]
  if(chooseBpDpFirst){
    bps = busData?.bps;
    dps = busData?.dps
  }
  const isSelected = (selectedBusIds.indexOf(bid) !== -1 || (!selectedLayouts[bid]  && selectedLinkName));
  let busSeatData = seatLayoutData[bid] || {};  
  let selectedSeatLayoutInfo = selectedLayouts[bid];
  const selectedSeats = selectedSeatLayoutInfo ? selectedSeatLayoutInfo['selectedSeats'] : {};
  let seats = [];
  useEffect(() => {
    const selectedLayoutsObj =Object.assign({},selectedLayouts);
    if(selectedLayoutsObj && selectedLayoutsObj[bid]){
    selectedLayoutsObj[bid].selectedTab = selectedLinkName;
    setSelectedSeatLayoutInfo(selectedLayoutsObj);
    }
  }, [selectedLinkName]);
  useEffect(() => {
    let setBPDP= false;
    const selectedLayoutsObj =Object.assign({},selectedLayouts);
    let bothBPDPSelected = selectedLayoutsObj[bid].selectedBP &&Object.keys(selectedLayoutsObj[bid].selectedBP).length && selectedLayoutsObj[bid].selectedDP && Object.keys(selectedLayoutsObj[bid].selectedDP).length;
  if(bothBPDPSelected){
    return;
  }
    if(chooseBpDpFirst){
  if(bps && bps.length === 1 || props?.isRTC){
    setBPDP = true;
    selectedLayoutsObj[bid].selectedBP = bps[0];
    
  }
  if(dps && dps.length ===1 || props?.isRTC){
    setBPDP = true;
    selectedLayoutsObj[bid].selectedDP = dps[0];
    
  }


   bothBPDPSelected = selectedLayoutsObj[bid].selectedBP &&Object.keys(selectedLayoutsObj[bid].selectedBP).length && selectedLayoutsObj[bid].selectedDP && Object.keys(selectedLayoutsObj[bid].selectedDP).length;
      
  if((!cat_card && (chooseBpDpFirst && bothBPDPSelected)) || (chooseBpDpFirst && bothBPDPSelected)){
    dispatch(fetchSeatLayoutData({busInfo:busData,selectedBP:bps[0],selectedDP:dps[0],cat_type:cat_card ? cat_list[selectedLayoutsObj[bid].selectedCategory]:'',fetch:true}));
}

    }else{
    if(busSeatData && busSeatData.data){
       
      if(busSeatData.data.bps && busSeatData.data.bps.length && busSeatData.data.bps.length ===1){
        setBPDP = true;
        selectedLayoutsObj[bid].selectedBP = busSeatData.data.bps[0];
      }
      if(busSeatData.data.dps && busSeatData.data.dps.length && busSeatData.data.dps.length ===1){
        setBPDP = true;
        selectedLayoutsObj[bid].selectedDP = busSeatData.data.dps[0];
      }
    }
    
    }
    if(setBPDP){
      setSelectedSeatLayoutInfo(selectedLayoutsObj);
      }
    
  }, [busSeatData,busSeatData.data,chooseBpDpFirst]);
 
 

  for(let deck in selectedSeats){
   if(selectedSeats.hasOwnProperty(deck)){
  seats= seats.concat(selectedSeats[deck]);
   }
 }
 
  /**************************************************************************************** */
  const fetchRedDeal = async ({initialValue,doj,seats,route_id, busData={}}) => {
  if(!initialValue){
     return {}
   }
  // const data = await fetchRedDealData(doj,route_id,seats);
  const data = await fetchRedDealDataNew(doj,route_id,seats,busData);
  return data;
};
function onRedDealInfoResolved(params){
  const selectedLayoutsObj =Object.assign({},selectedLayouts);
   selectedSeatLayoutInfo.redDealInfo = params;
   selectedLayoutsObj[bid] = selectedSeatLayoutInfo;
   setFareUpdateFlag(false);
  
   setSelectedSeatLayoutInfo(selectedLayoutsObj);
  
  }

const debouncedRedDeal = useConstant(() =>
awesomeDebouncePromise(fetchRedDeal, 150),
);

const {data, isPending, isRejected, error} = useAsync({
  promiseFn: debouncedRedDeal,
  initialValue:seats.length,
//  watch:seats.length,
  onResolve:onRedDealInfoResolved,
  doj,
  seats,
  busData,
  route_id:busSeatData && busSeatData.data ? busSeatData.data.route_id:'',
  isRedDeal:busData?.isRedDeal,
  watchFn:function name(params,previousParams) {
      if(params.isRedDeal && params.seats.length !== previousParams.seats.length){
      return true;
    }
    return false;
  }
 
});
/****************************************************************************************/
  
  if(!selectedLayouts.hasOwnProperty(bid) && isSelected ){
       selectedLayouts[bid] = getSelectedSeatInitInfo(selectedLinkName,cat_card,cat_list);
       setSelectedSeatLayoutInfo(selectedLayouts);
    }
    
    selectedSeatLayoutInfo = selectedLayouts[bid];
    let selectedTab = '';
    if(selectedSeatLayoutInfo){
      selectedTab = selectedSeatLayoutInfo.selectedTab;
 
    }
    if((chooseBpDpFirst && !isSelected ) ||  !selectedTab){
       return null;
     }
  const ratingAndReview = ratingAndReviewData[bid];
  const busDetailsInfo = function(){
    if(busDetails && busDetails[bid]){
      return {...busDetails[bid]}

    }
  return {}      
  }() 
  
  
    return(
  
        <S.TabsCardWrap>
          <form name="bookingReview" id="bookingReview" action="" encType="application/x-www-form-urlencoded" method="post"></form>
           {popupContent && Object.keys(popupContent).length && popupContent.content ? (
          <Popup
            title={popupContent.title}
            content={[
              <div
                key="reviewPopupContent"
                dangerouslySetInnerHTML={{__html: popupContent.content}}
              ></div>,
            ]}
            onCloseClick={() => {
              setPopupContent({title: '', content: ''});
            }}
          ></Popup>
        ) : null}
       
          {/* tabs  TODO:- place the seatlayout section seperate from this so all selector and rendering will restrict accordingly */}
          <BusDetailedTabs selectedTab={selectedTab} onTabSelect={(evt)=>{
              const val = evt.target.dataset.val;
               props.setSelectedTab(val);
               const selectedLayoutsObj =Object.assign({},selectedLayouts);
              //  selectedLayoutsObj[bid].selectedDP ={}
              //  selectedLayoutsObj[bid].selectedBP ={}
             
               selectedLayoutsObj[bid].selectedTab = val;
               setSelectedSeatLayoutInfo(selectedLayoutsObj);
               if(val === 'boarding_dropping') pushCtaOmniEvents('BP_DP', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
               
               if(val === "amenities_photos") pushCtaOmniEvents('Amenities_Photos', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
               
               if (val == "reviews")pushCtaOmniEvents('Reviews', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    

               if(val === 'boarding_dropping' || val === "amenities_photos" || val == "reviews"){
                 dispatch(fetchBusDetails(busData))
               }
                else if(val === 'policies'){
                  pushCtaOmniEvents('Policies', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
                  let cancellationData= Object.assign({},cancellationPolicyData);
                  if(!cancellationData[bid]){
                    cancellationData[bid] = {} ;
                
                  }
                  cancellationData[bid]['isLoading'] = true ;
                
                  setCancellationPolicyData(cancellationData);
             
              const res =   dispatch(fetchCancellationPolicy(bid, src_vid, dest_vid)); 
              res.then((r)=>{
                let cancellationData= Object.assign({},cancellationPolicyData);
                if(!cancellationData[bid]){
                  cancellationData[bid] = {} ;
                }
              
                cancellationData[bid].data = r.data;
                if(r.data && r.data.error || r.data.api_error){
                  cancellationData[bid]['error'] = true ;
                  
                }
                cancellationData[bid]['isLoading'] = false ;
                  

                setCancellationPolicyData(cancellationData);
              }).catch((err)=>{
                let cancellationData= Object.assign({},cancellationPolicyData);
                if(!cancellationData[bid]){
                  cancellationData[bid] = {} ;
              
                }
              
                cancellationData[bid]['error'] = true;
                cancellationData[bid]['isLoading'] = false ;
                setCancellationPolicyData(cancellationData);

              })

               }else if(val === 'seatLayout'){
                pushCtaOmniEvents('Select Seats tab selected', CTA_TYPE.BUTTON, 'Card_footer', 'SRP');    
                pushEcommerceGAEvent({
                  pageViewEvents:{
                  cdBusSearchDestination:busData.origin,
                  cdBusSearchOrigin: busData.destination,
                  cdBusSearchReturnDate:"",
                  cdCatQuery: "bus-domestic",
                  cdSubCatQuery: "OneWay",
                  cdVisitorSegment: "",
                  userid: "",
                  },
                  event: "virtualPageView",
                  virtualPage: "srp?page=busSeatSelection",
                  });
                if(!chooseBpDpFirst && !cat_card){
                dispatch(fetchSeatLayoutData({busInfo:busData}));
                }else{
                    dispatch(updateSelectedBusData({bid: bid, data: busSeatData && busSeatData.data ? busSeatData.data : {},isLoading:false,error:false}));
            
                }
               }
               pushga({
                event: SeatLayoutEvents.actions.bus_seatlayout_tab.val,
                eventCategory: SeatLayoutEvents.category,
                eventAction: SeatLayoutEvents.actions.bus_seatlayout_tab.val,
                eventLabel:SeatLayoutEvents.actions.bus_seatlayout_tab.labels[val]
              });
       
           
          }}/>
          {/* tab content */}
        {selectedTab === 'seatLayout' ? <SelectSeatTabContent
        bps={bps}
        dps={dps}
        bid={bid}
        cat_list={cat_list}
        busSeatData={busSeatData} selectedSeatLayoutInfo={selectedSeatLayoutInfo}  cat_card={cat_card}
        redDealData={data}
        chooseBpDpFirst={chooseBpDpFirst}
        isFareUpdating={isFareUpdating}
        routeId={routeId}
        busData={busData}
        onCategorySelect={(evt)=>{
      const value = evt.target.value;
      const selectedLayoutsObj =Object.assign({},selectedLayouts);
      selectedLayoutsObj[bid].selectedCategory = value;
      selectedLayoutsObj[bid].selectedSeats = [];
      
      setSelectedSeatLayoutInfo(selectedLayoutsObj);
      const selectedDP = selectedLayoutsObj[bid].selectedDP;
      const selectedBP = selectedLayoutsObj[bid].selectedBP;
     
          
      if(!chooseBpDpFirst || (chooseBpDpFirst && selectedDP &&Object.keys(selectedDP).length && selectedBP && Object.keys(selectedBP).length)){
       dispatch(fetchSeatLayoutData({busInfo:busData,cat_type:cat_list[value],fetch:true,selectedDP, selectedBP}));
       
      }

        }}
         onSeatClick={(data)=>{
           if(busData.isRedDeal){

           
           setFareUpdateFlag(true);
           }

        const{bid} = data;
        const selectedCategory = selectedSeatLayoutInfo.selectedCategory;
        const selectedSeats = selectedSeatLayoutInfo.selectedSeats;
        let selectedSeatCount = function(){
          let count =0;
          if(selectedSeats && Object.keys(selectedSeats).length){
            for(const deck in selectedSeats){
              count += selectedSeats[deck].length
            }
          }
        return count;
        }()
      const maxSeatCount = busData && busData.op  && busData.op == "15499" ? 4 :6; 
      if(selectedSeats && (selectedSeats[data.deck] &&  selectedSeats[data.deck].indexOf(data.sn) === -1 || !selectedSeats[data.deck]) && (cat_list[selectedCategory] && selectedSeatCount+1 > cat_list[selectedCategory].ms || (!cat_card && selectedSeatCount >= maxSeatCount)) ){
        const type =  busData.op == "15499" ? busData.op : 'gen';
        setPopupContent({title: 'Information ', content: `<div>${categoryConfig[selectedCategory || type].message}</div>`});
          setFareUpdateFlag(false);

          return;
        }
        const result =  onSeatClick(data,Object.assign({},selectedSeatLayoutInfo));
       
               const selectedLayoutsObj =Object.assign({},selectedLayouts);
    
        selectedLayoutsObj[bid] = result;
        setSelectedSeatLayoutInfo(selectedLayoutsObj);
        props.setSelectedSeatCopy(selectedLayoutsObj)
        if(selectedSeats && (selectedSeats[data.deck] &&  selectedSeats[data.deck].indexOf(data.sn) !== -1 ||  !selectedSeats[data.deck])){
        pushga({
          event: SeatLayoutEvents.actions.selectseat,
          eventCategory: SeatLayoutEvents.category,
          eventAction: SeatLayoutEvents.actions.selectseat,
        });
        }
        
        }}
        
        onPriceSelect={(data)=>{
          const {bid}= data;
          const result = onPriceSelect(data);
          const selectedLayoutsObj =Object.assign({},selectedLayouts);
          selectedLayoutsObj[bid] = result;
          setSelectedSeatLayoutInfo(selectedLayoutsObj);
          pushga({
            event: SeatLayoutEvents.actions.priceChange,
            eventCategory: SeatLayoutEvents.category,
            eventAction: SeatLayoutEvents.actions.priceChange,
          });
          
         
        }}
        onDroppingPointSelect={(data)=>{
         
          const result = onDroppingPointSelect(data,Object.assign({},selectedSeatLayoutInfo));
          const selectedLayoutsObj =Object.assign({},selectedLayouts);
          selectedLayoutsObj[bid] = result;
          const selectedDP = result.selectedDP;
          const selectedBP = result.selectedBP;
          setSelectedSeatLayoutInfo(selectedLayoutsObj);
          const bothBPDPSelected = selectedDP &&Object.keys(selectedDP).length && selectedBP && Object.keys(selectedBP).length;
          if(bothBPDPSelected){
            scrolltoSeatView(routeId)
          }
        if((!cat_card && (chooseBpDpFirst && bothBPDPSelected)) || (chooseBpDpFirst && bothBPDPSelected)){
              dispatch(fetchSeatLayoutData({busInfo:busData,selectedBP,selectedDP,cat_type:cat_card ? cat_list[selectedLayoutsObj[bid].selectedCategory]:'',fetch:true}));
          }
      
        }
      }        
        onBoardingPointSelect={(data)=>{
          const result = onBoardingPointSelect(data,Object.assign({},selectedSeatLayoutInfo));
          const selectedLayoutsObj =Object.assign({},selectedLayouts);
          selectedLayoutsObj[bid] = result;
          const selectedDP = result.selectedDP;
          const selectedBP = result.selectedBP;
          setSelectedSeatLayoutInfo(selectedLayoutsObj);
          const bothBPDPSelected = selectedDP &&Object.keys(selectedDP).length && selectedBP && Object.keys(selectedBP).length;
          if(bothBPDPSelected){
            scrolltoSeatView(routeId)
          }
  
          if((!cat_card && (chooseBpDpFirst && bothBPDPSelected)) || (chooseBpDpFirst && bothBPDPSelected)){
                dispatch(fetchSeatLayoutData({busInfo:busData,selectedBP,selectedDP,cat_type:cat_card ? cat_list[selectedLayoutsObj[bid].selectedCategory]:'',fetch:true}));
            }
       
        }
        }
        onContinueSeat={()=>{
          const searchStr = window.location.search;
          const page_source = getQueryString('page_source',searchStr)
  const seatData = selectedLayouts[bid];
  let seats = [];
  const selectedSeats = seatData.selectedSeats
  const bpDetail=  seatData.selectedBP && Object.keys(seatData.selectedBP).length ? seatData.selectedBP: busSeatData.data.bps[0];
  const dpDetail = seatData.selectedDP && Object.keys(seatData.selectedDP).length ? seatData.selectedDP: busSeatData.data.dps[0];
  const bps = busSeatData.data.bps;
  const dps = busSeatData.data.dps;
  
  let selectedSeatsData = []
  for(const key in selectedSeats){
    if(selectedSeats.hasOwnProperty(key)){
      seats = seats.concat(selectedSeats[key]);
      for(const s in seats){
        if(busSeatData.data.seats[key][seats[s]]){
          selectedSeatsData.push(busSeatData.data.seats[key][seats[s]]);
        }
      }
    }
  }
  
  const {origin:src,destination:dest,src_vid,dest_vid,fh:routeId,journey_date,searchtype:journeyType,fd} = busData;
  const doj= journey_date.split("-").join("");
  const querydata = prepareQueryData({src,dest,doj,src_vid,dest_vid,seats});
  const bookingKey=prepareBookingKey({src,dest,src_vid,dest_vid,doj,seats,routeId,bpDetail,dpDetail});
  const redDealsDiscount= selectedSeatLayoutInfo.redDealInfo && selectedSeatLayoutInfo.redDealInfo.seats && Object.keys(selectedSeatLayoutInfo.redDealInfo.seats).length  ? selectedSeatLayoutInfo.redDealInfo : {};
  let cat_card_selected ={}
  if(selectedSeatLayoutInfo.selectedCategory){
  cat_card_selected = cat_list[selectedSeatLayoutInfo.selectedCategory]
  }
pushga({
  event: SeatLayoutEvents.actions.proceedToReview,
  eventCategory: SeatLayoutEvents.category,
  eventAction: SeatLayoutEvents.actions.proceedToReview,
});
  dispatch(fetchReviewData({src,dest,src_vid,dest_vid,doj,routeId,bpDetail,dpDetail,seats,selectedSeatsData,journeyType,fd,bookingKey,querydata,redDealsDiscount,cat_card_selected,page_source:page_source}));

 let url = getReviewPageURL({bookingKey,querydata:querydata.replace('#', ''),routeId,page_source:page_source, is_sponsored: props.is_sponsored, is_bo_ads:props.is_bo_ads});
 
 

  history.push(url);
  pushDataToNewrelic(`reviewVal=review&bookingKey=${bookingKey}&querydata=${querydata.replace('#', '')}&routeId=${routeId}`);

  return ;



//  url = getOldReviewPageURL({bookingKey,querydata:querydata.replace('#', ''),routeId});

// const bookingData =  prepareBookingData({selectedSeatsData,routeId,journeyType,bpDetail,dpDetail,fd,redDealsDiscount,cat_card_selected,busData,bps,dps})
       
// let formEle  = document.getElementById("bookingReview");


// let action = `${__ENV_CONFIG__.__GOIBIBO__}${url}`;

// formEle.setAttribute("action",action);
//   const hiddenField = document.createElement('input');
//             hiddenField.type = 'hidden';
//             hiddenField.name = "bookingdata";
//          hiddenField.value = JSON.stringify([{"of":bookingData}]);
//         formEle.appendChild(hiddenField);
//     const hiddenField1 = document.createElement('input');
//     hiddenField1.type = 'hidden';
//     hiddenField1.name = "querydata";
//     hiddenField1.value = querydata;
//   formEle.appendChild(hiddenField1);
//          formEle.submit();

   
   
        }}
        
        /> :null} 
    
        {selectedTab === 'amenities_photos' ? <AmenitiesPhotos isLoading={busDetailsInfo.isLoading} error={busDetailsInfo.error}  data={busDetailsInfo.data}    routeId={routeId}
      />:null}
        {selectedTab === 'reviews'?    (
                                      <>
                                      <RnRTabContent
                                      isLoading={busDetailsInfo.isLoading} error={busDetailsInfo.error}  data={busDetailsInfo.data}
                                      
                                     bid={bid} onShowAllReview={()=>{
                                        toggleAllReviewView(true)
                                        dispatch(fetchRatingReviewData({bid,routeId}))
                                        }}/>
                                      {showAllReview  ? <RnRPopup data={ratingAndReview} bid={bid} 
                                      
                                      busDetailsInfo={busDetailsInfo.data}
                                      onClose={()=>{
                                        toggleAllReviewView(false)}}/> :null}
                                    </>) : null }
         {selectedTab === 'policies' ?   <PolicesContent isLoading={cancellationPolicyData[bid].isLoading} error={cancellationPolicyData[bid].error} cancellationPolicyData={cancellationPolicyData[bid].data}/>:null}
    
         {selectedTab === 'boarding_dropping'  ?  <BoardingDroping  isLoading={busDetailsInfo.isLoading} error={busDetailsInfo.error}  data={busDetailsInfo.data}    routeId={routeId}
     
         
         /> :null}
        </S.TabsCardWrap>)

    }

export default SeatSectionWrapper;

function getSelectedSeatInitInfo(selectedLinkName,cat_card,cat_list){
  return {
    isFetching:false,
    selectedTab:selectedLinkName || Object.keys(seatTabConfig)[0],
    selectedSeats:{},
    selectedCategory:cat_card ? Object.keys(cat_list)[0]: '',
    selectedBP:{},
    selectedDP:{},
    availableSeatPrice:[-1],
    selectedPrice:[-1],
    fareInfo:{priceAfterDiscount:0,priceWithoutDiscount:0,discount:0},
    data:{},
    redDealInfo:{}
   }
} 
function initSelectedSeatLayoutInfo(){
  return {}
}
function onSeatClick(data,selectedSeatLayoutInfo){
  const {sn,deck,priceAfterDiscount,priceWithoutDiscount,discount} = data;
  if(!selectedSeatLayoutInfo.selectedSeats[deck]){
    selectedSeatLayoutInfo.selectedSeats[deck]=[];
  
  }
  const selectedSeats = [...selectedSeatLayoutInfo.selectedSeats[deck]];// move this to selctor;
  const fareInfo = selectedSeatLayoutInfo.fareInfo;
  const index = selectedSeats.indexOf(sn);
                if(index !== -1){
                  selectedSeats.splice(index,1);
                  selectedSeatLayoutInfo.selectedSeats[deck] = [...selectedSeats]
                  fareInfo.priceAfterDiscount -=priceAfterDiscount ;
                fareInfo.priceWithoutDiscount -= priceWithoutDiscount;
                fareInfo.discount-=discount;  
  
                }else{
                  selectedSeatLayoutInfo.selectedSeats[deck].push(sn);
                fareInfo.priceAfterDiscount +=priceAfterDiscount ;
                fareInfo.priceWithoutDiscount += priceWithoutDiscount;
                fareInfo.discount+=discount;  
                }
               
            return selectedSeatLayoutInfo; 
  
}


function onPriceSelect(data) {
  const {price,selectedSeatLayoutInfo} = data;
  //TODO:- do not call action if click on all button with all already selected.
  var selectedPrice = selectedSeatLayoutInfo.selectedPrice;// move this to selctor;
  if(price === -1){
    selectedPrice = [-1];
  }else{
    if(selectedPrice.indexOf(-1) !== -1){
      selectedPrice = [];
      selectedPrice.push(price); 
 
    }else{
      const index =selectedPrice.indexOf(price);
    if(index !== -1){
      selectedPrice.splice(index,index+1);
      selectedPrice = !selectedPrice.length ? [-1]: selectedPrice ; 

    }else{
      selectedPrice.push(price); 
    }
    }
   }
  selectedSeatLayoutInfo.selectedPrice=selectedPrice;
   return selectedSeatLayoutInfo;
}

function onBoardingPointSelect(item,selectedSeatLayoutInfo){
  if(selectedSeatLayoutInfo.selectedBP.id === item.id){
    selectedSeatLayoutInfo.selectedBP={};
  }else{  
  selectedSeatLayoutInfo.selectedBP=item;
  }
return selectedSeatLayoutInfo;

}
function onDroppingPointSelect(item,selectedSeatLayoutInfo) {
  if(selectedSeatLayoutInfo.selectedDP.id === item.id){
    selectedSeatLayoutInfo.selectedDP={};
  }else{  
    selectedSeatLayoutInfo.selectedDP=item;
  }
  return selectedSeatLayoutInfo;
 
}
function scrolltoSeatView(routeId){
  const idOfElToScrollTo = `#seatSection${routeId.replace('@', '')}`;
  scrollEletoView(idOfElToScrollTo, {
    behavior: 'smooth',
    block:'center'
  });

}